import axios from 'axios'
import { useToast } from 'vuestic-ui'
import Constant from '@/constants/Constant'
import router from '@/router'

// Cho phép gắn cờ skipGlobalError trên request config để bỏ qua toast lỗi toàn cục
declare module 'axios' {
  export interface AxiosRequestConfig {
    skipGlobalError?: boolean
  }
}

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.ttlogistics.com',
  timeout: 90000, // 90 giay moi bi timeout
})

const { init } = useToast()

// const REFRESH_TOKEN_URL = '/api/v1/auth/refresh-token'

// // Hang doi cac request bi 401 trong luc dang refresh token, tranh goi refresh nhieu lan song song
// let isRefreshingToken = false
// let pendingRequests: Array<(newAccessToken: string | null) => void> = []

// function subscribeTokenRefresh(callback: (newAccessToken: string | null) => void) {
//   pendingRequests.push(callback)
// }

// function notifyTokenRefreshed(newAccessToken: string | null) {
//   pendingRequests.forEach((callback) => callback(newAccessToken))
//   pendingRequests = []
// }

function forceLogout() {
  showNotification('Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.')
  localStorage.removeItem(Constant.ACCESS_TOKEN)
  localStorage.removeItem(Constant.REFRESH_TOKEN)
  router.push({ name: 'login' }).catch(() => {})
}

// // Goi API refresh-token bang axios "tran" de khong di qua interceptor nay (tranh de quy)
// async function requestNewAccessToken(refreshToken: string) {
//   const response = await axios.post(
//     `${axiosInstance.defaults.baseURL}${REFRESH_TOKEN_URL}`,
//     { refresh_token: refreshToken },
//     { headers: { Authorization: '' } },
//   )
//   return response.data?.data
// }

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(Constant.ACCESS_TOKEN)
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

// Response Interceptor
// Tư tưởng: Bắn lỗi toàn cục, nếu có 1 vài trường hợp đặc biệt (httpCode=400, code trả về theo Nghiệp vụ cần handle riêng ở Component thì khai báo)
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {}
    const status = error.response?.status
    const data = error.response?.data || {}
    const code = data.code
    const message = data.message || 'Có lỗi xảy ra'
    // Cho phép 1 số request tự xử lý lỗi, không bắn toast toàn cục (vd: GET /permissions/me khi BE chưa sẵn sàng)
    const skip = config.skipGlobalError === true

    switch (status) {
      case 400:
        // Nếu là code 999, 997, 998 (hoặc TT_516 - conflict PATCH /update) thì để component xử lý riêng. Còn đâu show luôn lỗi ở global
        if ([999, 997, 998, 'TT_516'].includes(code)) {
          error._handled = false
        } else {
          if (!skip) showNotification(message)
          error._handled = true
        }
        break

      case 401: {
        error._handled = true

        // // Access token het han giua chung -> thu refresh roi goi lai request cu, chi dang xuat khi refresh that bai
        // const isRefreshCall = config.url?.includes(REFRESH_TOKEN_URL)
        // const refreshToken = localStorage.getItem(Constant.REFRESH_TOKEN)
        // if (!isRefreshCall && !config._retried && refreshToken) {
        //   config._retried = true
        //   const waitForNewAccessToken = new Promise<string | null>((resolve) => subscribeTokenRefresh(resolve))
        //   if (!isRefreshingToken) {
        //     isRefreshingToken = true
        //     requestNewAccessToken(refreshToken)
        //       .then(({ access_token, refresh_token: newRefreshToken }) => {
        //         localStorage.setItem(Constant.ACCESS_TOKEN, access_token)
        //         if (newRefreshToken) {
        //           localStorage.setItem(Constant.REFRESH_TOKEN, newRefreshToken)
        //         }
        //         notifyTokenRefreshed(access_token)
        //       })
        //       .catch(() => {
        //         notifyTokenRefreshed(null)
        //       })
        //       .finally(() => {
        //         isRefreshingToken = false
        //       })
        //   }
        //   const newAccessToken = await waitForNewAccessToken
        //   if (!newAccessToken) {
        //     forceLogout()
        //     return Promise.reject(error)
        //   }
        //   config.headers['Authorization'] = `Bearer ${newAccessToken}`
        //   return axiosInstance(config)
        // }

        forceLogout()
        break
      }

      case 403:
        if (!skip) showNotification('Bạn không có quyền truy cập tính năng này.')
        error._handled = true
        break

      case 500:
        if (!skip) showNotification('Hệ thống đang nâng cấp. Vui lòng thử lại sau.')
        error._handled = true
        break

      default:
        if (!skip) showNotification(message)
        error._handled = true
        break
    }

    return Promise.reject(error)
  },
)

// Global notification
function showNotification(message: string) {
  init({
    message,
    color: 'danger',
    position: 'top-right',
  })
}

export default axiosInstance
